import React from "react";

import { t } from "i18n/i18n";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { AddPlusIcon, SubtractMinusIcon } from "mds/icons";

type ZoomToolbarProps = {
  setZoom: (value: number) => void;
  zoom: number;
};

export const DEFAULT_ZOOM = 100;
const MAX_ZOOM_PERCENT = 400;
const MIN_ZOOM_PERCENT = 25;
const ZOOM_STEP = 25;

export const ZoomToolbar: React.FC<ZoomToolbarProps> = ({ setZoom, zoom }) => {
  const zoomIn = () => {
    const newZoom = zoom + ZOOM_STEP;
    setZoom(newZoom > MAX_ZOOM_PERCENT ? MAX_ZOOM_PERCENT : newZoom);
  };

  const zoomOut = () => {
    const newZoom = zoom - ZOOM_STEP;
    setZoom(newZoom < MIN_ZOOM_PERCENT ? MIN_ZOOM_PERCENT : newZoom);
  };

  return (
    <div className="zoom-toolbar flex items-center gap-2">
      <SquareIconButton
        aria-label={t("common.zoom_out")}
        disabled={zoom <= MIN_ZOOM_PERCENT}
        kind="tertiary"
        size="s"
        onClick={zoomOut}
      >
        <SubtractMinusIcon />
      </SquareIconButton>

      <span className="page-toolbar__label body-s text-black-tint-20">
        {t("common.percentage", { number: zoom })}
      </span>

      <SquareIconButton
        aria-label={t("common.zoom_in")}
        disabled={zoom >= MAX_ZOOM_PERCENT}
        kind="tertiary"
        size="s"
        onClick={zoomIn}
      >
        <AddPlusIcon />
      </SquareIconButton>
    </div>
  );
};
